import React from 'react';
import { HotspotForm } from '../../components/Hotspot';
import { InteractiveWrapper } from '../../components/Interface';
import { Hotspot as HotspotTemplate } from '../../components/Templates';

export const Hotspot = () => {
    return (
      <InteractiveWrapper 
        name="hotspot"
        title="Hotspot"
        template={HotspotTemplate}
        initFunction="initHotspot"
        hasStyles={true}
        topPadding={true}
      >
        <HotspotForm />
      </InteractiveWrapper>
    )
}
